<template>
    <div id="bilant-form">
        <div class="bilant-info">
            <h3> {{ bilantCod }}</h3>
        </div>



        <DxDataGrid ref="dataGridRef" :allowColumnReordering="true" :data-source="filteredStore"
            :allowColumnResizing="true" key-expr="ID" :columnAutoWidth="false" :columnMinWidth="50"
            :columnResizingMode="'nextColumn'" :show-borders="true" :syncLookupFilterValues="false"
            :filter-sync-enabled="true" show-row-lines="true" show-column-lines="false"
            @selection-changed="handleRowSelection" :hover-state-enabled="true" @row-inserting="onRowInserting"
            @row-removing="onRowRemoving" class="border">
            <DxSelection mode="single" />
            <DxFilterRow :visible="true" />
            <DxPaging :page-size="5" :page-index="1" />
            <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
            <DxSorting mode="multiple" />
            <DxStateStoring :enabled="true" :filterValue="false" storage-key="BilantRanduri" />
            <DxToolbar>
                <DxItem>
                    <template #default>
                        <DxButton icon="add" type="success" @click="onAddClick" />
                    </template>
                </DxItem>
                <DxItem>
                    <template #default>
                        <DxButton icon="refresh" @click="onRefreshClick" />
                    </template>
                </DxItem>
            </DxToolbar>
            <DxEditing :allowUpdating="true" :allowDeleting="true" mode="popup" @click="onRowRemoving">
                <DxPopup :closeOnOutsideClick="false" :showCloseButton="false" :width="650" :height="450">
                    <DxToolbarItem :template="customTitleTemplate" />
                    <DxToolbarItem toolbar="bottom" widget="dxButton" location="after"
                        :options="successButtonOptions" />
                    <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="dangerButtonOptions" />
                </DxPopup>
                <DxFormGrid>
                    <DxItem :col-span="2" :col-count="2" item-type="group">

                        <DxItem data-field="NrCrt" />
                        <DxItem data-field="CodRand" />
                        <DxItem data-field="Denumire" />
                        <DxItem data-field="TextGrupare" />
                        <DxItem data-field="Expresie" />
                        <DxItem data-field="ExpPtCorelatiiRanduri" />
                        <DxItem data-field="OrdineCalculExpresie" />
                    </DxItem>
                </DxFormGrid>
            </DxEditing>
            <DxColumn data-field="NrCrt" />
            <DxColumn data-field="Denumire" />
            <DxColumn data-field="CodRand" />
            <DxColumn data-field="TextGrupare" />
            <DxColumn data-field="Expresie" />
            <DxColumn dataField="BilantID" :visible="false" :lookup="{
                dataSource: dsBilanturi,
                valueExpr: 'ID',
                displayExpr: 'Cod'
            }" />
            <DxColumn data-field="ExpPtCorelatiiRanduri" :visible="false" />
            <DxColumn data-field="OrdineCalculExpresie" :visible="false" />
        </DxDataGrid>
        <DxPopupAdd :visible.sync="isModalVisible" :closeOnOutsideClick="false" :showCloseButton="false"
            :showTitle="true" :width="650" :height="500">
            <template #title>
                <div
                    style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold;  padding: 10px; padding-left: 20px; ">
                    Adăugare</div>
            </template>
            <div>
                <DxForm :formData="formData">
                    <DxItem :col-span="2" :col-count="2" item-type="group">

                        <DxItem data-field="NrCrt" />
                        <DxItem data-field="CodRand" />
                        <DxItem data-field="Denumire" />
                        <DxItem data-field="TextGrupare" />
                        <DxItem data-field="Expresie" />
                        <DxItem data-field="ExpPtCorelatiiRanduri" editor-type="dxCheckBox" />
                        <DxItem data-field="OrdineCalculExpresie" />
                    </DxItem>
                </DxForm>
                <div style="display: flex; justify-content: flex-end; gap: 8px;">
                    <DxButton text="Salvează" type="success" width="100" @click="onSaveAdd" />
                    <DxButton text="Închide" type="danger" width="100" @click="onCancel" />
                </div>
            </div>
        </DxPopupAdd>
    </div>
</template>
<script lang="ts">
import { defineComponent, ref } from 'vue';
import { DxButton } from 'devextreme-vue/button';
import DxPopupAdd, { DxToolbarItem } from 'devextreme-vue/popup';
import { DxItem, DxForm, DxLabel } from 'devextreme-vue/form';
import {
    DxColumn,
    DxDataGrid,
    DxFilterRow,
    DxLoadPanel,
    DxPaging,
    DxSelection,
    DxSorting,
    DxStateStoring,
    DxToolbar,
    DxEditing,
    DxPopup,
    DxItem as DxItemForm,
    DxForm as DxFormGrid,
    DxValidationRule,
    DxRequiredRule,
} from 'devextreme-vue/data-grid';
import 'devextreme/dist/css/dx.light.css';
import 'devextreme/dist/css/dx.common.css';
import ODataStore from 'devextreme/data/odata/store';
import AppSetting from '@/settings/appSettings';
import notify from 'devextreme/ui/notify';
import { locale, loadMessages } from 'devextreme/localization';
import { DxLookup } from 'devextreme-vue';
import ConBilantRanduri from '@/services/Contabilitate/ConBilantRanduri';
import { visible } from 'devexpress-reporting/scopes/reporting-chart-internal';
export default defineComponent({
    components: {
        DxToolbar,
        DxDataGrid,
        DxColumn,
        DxSorting,
        DxSelection,
        DxFilterRow,
        DxStateStoring,
        DxLoadPanel,
        DxPaging,
        DxButton,
        DxItem,
        DxPopup,
        DxForm,
        DxLabel,
        DxEditing,
        DxPopupAdd,
        DxToolbarItem,
        DxItemForm,
        DxFormGrid,
        DxValidationRule,
        DxRequiredRule,
        DxLookup
    },

    data() {
        return {
            ds: null,
            filteredStore: null,
            dsBilantRanduri: {} as ODataStore,
            dsBilanturi: {} as ODataStore,
            isModalVisible: false,
            bilantCod: '',
            formData: {
                BilantID: '',
                NrCrt: '',
                CodRand: '',
                Denumire: '',
                TextGrupare: '',
                Expresie: '',
                ExpPtCorelatiiRanduri: null,
                OrdineCalculExpresie: null
            },
            deleteConfirmationMessage: "Sigur doriți să ștergeți această înregistrare?",
            dataGridRef: ref<DxDataGrid | null>(null),
            successButtonOptions: {
                type: 'success',
                stylingMode: 'contained',
                text: 'Salvează',
                onClick: () => {
                    this.onSaveEdit();
                },
            },
            dangerButtonOptions: {
                type: 'danger',
                stylingMode: 'contained',
                text: 'Închide',
                onClick: () => {
                    this.onCancelEdit();
                },
            },
            customTitleTemplate() {
                return `
        <div style="background-color: #ff2c21; font-size: 16px; float: right; height:47px; width:670px; color: white; 
        font-weight: bold;  padding: 12px; padding-right: 450px;  position: relative;  left: 30px;">
          Editare
        </div>
      `;
            },
        };
    },


    methods: {
        createODataContext() {
            this.dsBilantRanduri = new ODataStore({
                url: AppSetting.API_Url_Contabilitate + 'CON_BilantRanduri',
                key: 'ID',
                version: 4,
                beforeSend: (e) => {
                    e.headers = {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt'),
                    };
                },
            });

        },
        handleRowSelection(e) {
            const selectedRow = e.selectedRowsData?.[0];
            if (selectedRow?.ID) {
                this.$emit('select-bilantrand', selectedRow.ID);
            }
        },
        onAddClick() {
            this.isModalVisible = true;
        },
        onSaveAdd() {
            console.log('BilantID în componentă:', this.BilantID);

            if (!this.BilantID) {
                notify('BilantID nu este setat!', 'error', 2000);
                return;
            }

            this.formData.BilantID = this.BilantID;

            console.log('formData final trimis:', this.formData);

            const body = this.formData;

            ConBilantRanduri.save(body).then((response) => {
                this.isModalVisible = false;
                notify('Datele au fost salvate cu succes!', 'success', 1000);
                this.formData = {
                    BilantID: '',
                    NrCrt: '',
                    CodRand: '',
                    Denumire: '',
                    TextGrupare: '',
                    Expresie: '',
                    ExpPtCorelatiiRanduri: null,
                    OrdineCalculExpresie: null
                };
            }).catch((error) => {
                console.error(error);
                notify('Datele există deja!', 'error', 1000);
            });

            this.createODataContext();
        },

        onCancel() {
            this.isModalVisible = false;
        },
        setDeleteConfirmationMessage() {
            const dataGrid = this.$refs.dataGridRef?.instance;
            dataGrid.option('editing', {
                allowUpdating: true,
                allowDeleting: true,
                mode: 'popup',
                texts: {
                    confirmDeleteMessage: this.deleteConfirmationMessage,
                    confirmDeleteTitle: "Confirmare Ștergere",
                }
            });
        },
        onClick() {
            this.isModalVisible = true;
        },
        onRefreshClick() {
            this.createODataContext();
            notify('Datele au fost actualizate cu succes!', 'success', 1000)
        },
        onSaveEdit() {
            const savePromise = this.$refs.dataGridRef?.instance?.saveEditData();
            savePromise.then((result) => {
                this.dataGridRef?.instance?.saveEditData();
            }).catch((error) => {
                console.error(error);
            });
            this.createODataContext();
        },
        onCancelEdit() {
            this.dataGridRef?.instance?.cancelEditData();
        },
        onRowRemoving(e: any) {
            e.cancel = new Promise((resolve) => {
                this.dataGridRef?.instance?.saveEditData();
                notify('Datele au fost șterse cu succes!', 'success', 1000);
                resolve(false);
            });
        },
        onRowInserting() {
            notify('Datele au fost adăugate cu succes!', 'success', 1000)
        },
    },
    props: {
        BilantID: {
            type: String,
            required: true
        }
    },
    async mounted() {
        this.ds = new ODataStore({
            url: AppSetting.API_Url_Contabilitate + 'CON_BilantRanduri',
            key: 'ID',
            version: 4,
            beforeSend: (e) => {
                e.headers = {
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt'),
                };
            },
        });

        this.filteredStore = {
            store: this.ds,
            filter: ['BilantID', '=', this.BilantID]
        };
        const store = new ODataStore({
            url: AppSetting.API_Url_Contabilitate + 'CON_Bilanturi',
            key: 'ID',
            version: 4,
            beforeSend: (e) => {
                e.headers = {
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt'),
                };
            }
        });

        try {
            const bilanturi = await store.load({ filter: ['ID', '=', this.BilantID] });

            if (bilanturi.length > 0) {
                this.bilantCod = bilanturi[0].Cod || 'lipsă Cod';
            } else {
                this.bilantCod = 'necunoscut';
            }
        } catch (e) {
            console.error('Eroare la fetch CON_Bilanturi:', e);
            this.bilantCod = 'necunoscut';
        }


        this.createODataContext();
        this.dataGridRef = this.$refs.dataGridRef as DxDataGrid;
        this.setDeleteConfirmationMessage();
        loadMessages({
            "ro": {
                "Yes": "Da",
                "No": "Nu",
            }
        });
        locale('ro');
    },
});
</script>
<style scoped>
.border {
    border-radius: 8px;
}
</style>
